import * as XLSX from 'xlsx';

import { IGetChartData } from "@src/app/interfaces/chart-params.interface";

export class GenerateXlsFileChartData {
    private chartData: IGetChartData[] = [];
    private selectedParams: number[] = [];
    private paramsNameList: Map<number, string>;

    constructor(chartData: IGetChartData[], selectedParams: number[], paramsNameList: Map<number, string>) {
        this.chartData = chartData;
        this.selectedParams = selectedParams;
        this.paramsNameList = paramsNameList;
    }

    public getXLSFile(fileName: string): void {
        const data = this.prepareDataToFile();
        const worksheet = XLSX.utils.json_to_sheet(data);

        const headers = Object.keys(data[0]);
        worksheet['!cols'] = headers.map(header => ({ wch: header.length + 2 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, `${fileName}.xls`);
    }

    private prepareDataToFile(): IGetChartData[] {
        const defaultParams = {
            ...this.selectedParams.reduce((acc: Object, el: number) => {
                return {
                    ...acc,
                    [this.paramsNameList.get(el) as string]: '',
                }
            }, {}),
        };

        const formatValue = (value: string | number): string => {
            if (typeof value === 'number') {
                return value.toFixed(1);
            }
            return value || '';
        }

       return this.chartData.map(
            (item) => {
                const objKeys = Object.keys(item).filter(key => key !== 'Time');

                return {
                    ...defaultParams,
                    ...objKeys.reduce((prev, curr: string) => ({
                        ...prev,
                        [this.paramsNameList.get(Number(curr)) as string]: formatValue(item[Number(curr)]),
                    }), {}),
                    Time: new Date(item.Time).toLocaleString(),
                }
            },
        );
    }
}
